// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #F98100;
}

.container {
  height: 300px;
  width: 300px;
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
.container .portal {
  height: 250px;
  width: 250px;
  background-color: #F98100;
  position: absolute;
  border-radius: 50%;
  left: 50%;
  margin-left: -125px;
  box-shadow: inset 0 0 40px #fff;
  display: table;
  font-size: 1.3rem;
}
.container .portal .label {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  color: white;
  letter-spacing: 0.5em;
  text-transform: uppercase;
  font-family: "source sans pro", sans-serif;
  font-weight: 600;
  opacity: 0.9;
  transition: 1s ease-in-out;
}
.container .portal .label-hidden {
  opacity: 0;
}
.container .circle {
  position: absolute;
  height: 250px;
  width: 300px;
  border-radius: 50%;
  display: inline-block;
  animation: spin 4s linear infinite;
  background-image: linear-gradient(#ffffff, rgba(255, 255, 255, 0.5019607843));
  left: 50%;
  margin-left: -150px;
  opacity: 0.2;
}
.container .circle-0 {
  animation-delay: 0;
}
.container .circle-1 {
  animation-delay: -0.2s;
}
.container .circle-2 {
  animation-delay: -0.4s;
}
.container .circle-3 {
  animation-delay: -0.5s;
}
.container .circle-4 {
  animation-delay: -2s;
}
.container .circle-5 {
  width: 330px;
  margin-left: -175px;
  animation-delay: -1.5s;
}
.container .circle-6 {
  width: 330px;
  margin-left: -175px;
  animation-delay: -0.4s;
}
.container I .circle-7 {
  width: 320px;
  height: 280px;
  margin-left: -175px;
  animation-delay: -0.7;
  margin-top: -140px;
}
.container .circle-8 {
  width: 320px;
  margin-left: -175px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/portal-animation/portal-animation.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEA;EAEE,aAAA;EACA,YAAA;AAAF;AAEE;EAAkB;IAA0C,yBAAA;EAG5D;AACF;AADE;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EAGA,+BAAA;EACA,cAAA;EACA,iBAAA;AACJ;AACI;EACE,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,0CAAA;EACA,gBAAA;EACA,YAAA;EACA,0BAAA;AACN;AAEI;EACE,UAAA;AAAN;AAIE;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,kCAAA;EACA,6EAAA;EACA,SAAA;EACA,mBAAA;EAGA,YAAA;AAJJ;AAOE;EACE,kBAAA;AALJ;AAOE;EACE,sBAAA;AALJ;AAOE;EACE,sBAAA;AALJ;AAOE;EACE,sBAAA;AALJ;AAOE;EACE,oBAAA;AALJ;AAOE;EACE,YAAA;EACA,mBAAA;EACA,sBAAA;AALJ;AAOE;EACE,YAAA;EACA,mBAAA;EACA,sBAAA;AALJ;AAMG;EAEC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;AALJ;AAOE;EACE,YAAA;EACA,mBAAA;AALJ","sourcesContent":["body {\n  background-color: #F98100;\n}\n\n.container {\n  \n  height: 300px;\n  width: 300px;\n  \n  @keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }\n\n  \n  .portal {\n    height: 250px;\n    width: 250px;\n    background-color: #F98100;\n    position: absolute;\n    border-radius: 50%;\n    left: 50%;\n    margin-left: -125px;\n    // top: 50%;\n    // margin-top: -125px;\n    box-shadow: inset 0 0 40px #fff;\n    display: table;\n    font-size: 1.3rem;\n\n    .label {\n      display: table-cell;\n      vertical-align: middle;\n      text-align: center;\n      color: white;\n      letter-spacing: 0.5em;\n      text-transform: uppercase;\n      font-family: \"source sans pro\", sans-serif;\n      font-weight: 600;\n      opacity: 0.9;\n      transition: 1s ease-in-out;\n    }\n\n    .label-hidden {\n      opacity: 0;\n    }\n  }\n  \n  .circle {\n    position: absolute;\n    height: 250px;\n    width: 300px;\n    border-radius: 50%;\n    display: inline-block;\n    animation: spin 4s linear infinite;\n    background-image: linear-gradient(#ffffff, #ffffff80);\n    left: 50%;\n    margin-left: -150px;\n    // top: 50%;\n    // margin-top: -125px;\n    opacity: 0.2;\n  }\n  \n  .circle-0 {\n    animation-delay: 0;\n  }\n  .circle-1 {\n    animation-delay: -0.2s;\n  }\n  .circle-2 {\n    animation-delay: -0.4s;\n  }\n  .circle-3 {\n    animation-delay: -0.5s;\n  }\n  .circle-4 {\n    animation-delay: -2s;\n  }\n  .circle-5 {\n    width: 330px;\n    margin-left: -175px;\n    animation-delay: -1.5s;\n  }\n  .circle-6 {\n    width: 330px;\n    margin-left: -175px;\n    animation-delay: -0.4s;\n  }I \n  .circle-7 {\n    width: 320px;\n    height: 280px;\n    margin-left: -175px;\n    animation-delay: -0.7;\n    margin-top: -140px;\n  }\n  .circle-8 {\n    width: 320px;\n    margin-left: -175px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
